var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "forgot-password-div" } }, [
    _c(
      "div",
      {
        staticClass: "d-flex align-items-center mb-2 page-title",
        on: { click: _vm.showLoginView }
      },
      [
        _vm._m(0),
        _vm._v(" "),
        _c("h1", { staticClass: "page-title ml-1" }, [
          _vm._v(_vm._s(_vm.$t("forgotTitle")))
        ])
      ]
    ),
    _vm._v(" "),
    !_vm.sendWithSuccess
      ? _c("h2", { staticClass: "page-subtitle mt-3" }, [
          _vm._v("\n    " + _vm._s(_vm.$t("forgotSubtitle")) + "\n  ")
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "form",
      {
        staticClass: "mt-4",
        on: {
          submit: function($event) {
            $event.stopPropagation()
            $event.preventDefault()
            return _vm.handleForgotSubmit.apply(null, arguments)
          }
        }
      },
      [
        _c(
          "b-alert",
          { attrs: { show: _vm.ui.showError, variant: "danger" } },
          [
            _vm._v("\n      " + _vm._s(_vm.ui.showErrorMessage) + "\n      "),
            _vm.ui.showValidateAccountError
              ? _c(
                  "a",
                  {
                    staticClass: "error-danger-link",
                    attrs: { href: "#" },
                    on: { click: _vm.resendValidateAccountMail }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("account.not.validated.resent.error")) +
                        "\n      "
                    )
                  ]
                )
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _c(
          "b-alert",
          {
            attrs: {
              show: _vm.ui.showResendValidateAccountMailSuccess,
              variant: "success"
            }
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("ResendValidateAccountMail.success")) +
                "\n    "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "b-alert",
          { attrs: { show: _vm.tokenIsExpired, variant: "danger" } },
          [
            _vm._v(
              "\n      " + _vm._s(_vm.$t("token.expired.error")) + "\n    "
            )
          ]
        ),
        _vm._v(" "),
        _vm.sendWithSuccess && !_vm.ui.showValidateAccountError
          ? _c(
              "div",
              { staticClass: "confirm-email mt-2" },
              [
                _c("check-icon", { staticClass: "check-icon-successful" }),
                _vm._v(" "),
                _c("p", { staticClass: "text-successful ml-2" }, [
                  _vm._v(_vm._s(this.$t("user.mail.send")))
                ])
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.sendWithSuccess && !_vm.ui.showValidateAccountError
          ? _c("div", { staticClass: "mt-3" }, [
              _c("p", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$t("Reset.password.mail.resent", {
                      mail: this.form.username.value
                    })
                  )
                }
              })
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "b-form-group",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.sendWithSuccess,
                expression: "!sendWithSuccess"
              }
            ],
            attrs: {
              label: _vm.$t("forgotCredential"),
              "label-for": "username-input"
            }
          },
          [
            _c("b-form-input", {
              attrs: { id: "username-input", required: "", type: "email" },
              on: { keydown: _vm.hideMessages },
              model: {
                value: _vm.form.username.value,
                callback: function($$v) {
                  _vm.$set(_vm.form.username, "value", $$v)
                },
                expression: "form.username.value"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mt-4" },
          [
            _c(
              "b-button",
              {
                staticClass: "btn-block bold-text",
                attrs: {
                  disabled: _vm.timer > 0,
                  type: "submit",
                  variant: "secondary"
                }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.timer > 0
                        ? _vm.$t("user.resend.mail.timer", {
                            timer: this.timer
                          })
                        : _vm.$t("forgotButtonText")
                    ) +
                    "\n      "
                )
              ]
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-button" }, [
      _c("i", { staticClass: "ph-custom ph-caret-left-fill" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d9d9ec7a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d9d9ec7a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/auth/components/ForgotPasswordComponent.vue
// module id = ntlE
// module chunks = 0